import type { AxiosError, AxiosInstance } from 'axios';
import { forceTermsCheckImperative } from '@/store/termsGateStore';

interface ConsentRequiredBody {
  code?: string;
}

/**
 * Backstop for the server-side ConsentGuard. If a guarded action returns
 * 403 `{ code: 'CONSENT_REQUIRED' }`, nudge the TermsGate to refetch pending
 * documents so the blocking modal appears even if the initial pending fetch
 * was missed. The original error still propagates to the caller.
 *
 * Returns a teardown function (useful for tests / HMR).
 */
export function installConsentInterceptor(instance: AxiosInstance): () => void {
  const id = instance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      const body = error.response?.data as ConsentRequiredBody | undefined;
      if (error.response?.status === 403 && body?.code === 'CONSENT_REQUIRED') {
        forceTermsCheckImperative();
      }
      throw error;
    },
  );
  return () => instance.interceptors.response.eject(id);
}
